export const getObjectKeys = <O extends object, K extends keyof O = keyof O>(
  obj: O,
  skipNumbers = false
): K[] => {
  if (!skipNumbers) return Object.keys(obj) as K[];
  return Object.keys(obj).filter((k) => Number.isNaN(+k)) as K[];
};

export const getEnumKeys = getObjectKeys;
